import React, {Component, SyntheticEvent} from 'react';
import {FormattedMessage} from 'react-intl';
import {MoreOrLess} from '@homeaway/react-collapse';
import FilterGroup from '../FilterGroup/FilterGroup';
import type {Refinement, RefinementTooltip} from '../FilterGroup/FilterGroup';

type Props = {
    // MoreOrLess-specific props
    checked: string[];
    expanded: boolean;
    filterGroupId: string;
    filters: Refinement[];
    groupName: string;
    handleChecked: (event: SyntheticEvent<HTMLInputElement>) => void;
    tooltipOptions: RefinementTooltip;
};

type State = {
    expanded: boolean;
};

export class FilterGroupExpandable extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: this.props.expanded,
        };
    }

    handleExpandedChange = (isExpanded: boolean) => {
        this.setState({expanded: isExpanded});
    };

    render() {
        const {
            checked,
            expanded,
            filterGroupId,
            filters,
            groupName,
            handleChecked,
            tooltipOptions,
        } = this.props;
        const isExpandedFromState = this.state.expanded;

        return (
            <MoreOrLess
                id={`MoreFilters--${filterGroupId}`}
                expanderPosition="block"
                lines={11}
                lineHeight={28}
                expanded={expanded}
                onExpandedChange={this.handleExpandedChange}
                moreText={
                    <FormattedMessage
                        id={'moreLabel'}
                        defaultMessage={'More'}
                        description={'Text for button to expand filter group'}
                    />
                }
                lessText={
                    <FormattedMessage
                        id={'lessLabel'}
                        defaultMessage={'Less'}
                        description={'Text for button to contract filter group'}
                    />
                }
            >
                <FilterGroup
                    handleChecked={handleChecked}
                    groupName={groupName}
                    filterGroupId={filterGroupId}
                    filters={filters}
                    checked={checked}
                    expanded={isExpandedFromState}
                    tooltipOptions={tooltipOptions}
                />
            </MoreOrLess>
        );
    }
}

export default FilterGroupExpandable;
